module.exports = __webpack_public_path__ + "images/degarage0bdce1f7f8a7def7554461472b3aff6f.png";